<template>
  <div id="app">
    <Header />
    <Search v-on:search="fetchMovies"/>
    <Movies v-if="this.opened == false" v-bind:data="data" v-on:open-movie="openMovie" />
    <Movie v-else v-bind:data="data" />
    <Footer />
  </div>
</template>

<script>
import Header from './components/Header';
import Search from './components/Search';
import Movies from './components/Movies';
import Movie  from './components/Movie';
import Footer from './components/Footer';

export default {
  name: 'App',
  data() {
    return {
      data: '',
      opened: false
    }
  },
  components: {
    Header,
    Search,
    Movies,
    Movie,
    Footer
  },
  methods: {
    fetchMovies(results) {
      this.data = results;

      this.opened = false;
    },

    openMovie(id) {
      fetch(`//www.omdbapi.com/?i=${id}&apikey=86b0b56b`)
      .then(res => {
        return res.json();
      }).then(this.setResults);
    },

    setResults(results) {
      this.data = results;

      this.opened = true;
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

</style>
